module.exports = __webpack_public_path__ + "static/media/holding.b47cb68c.png";